/** Émis après toute écriture locale d'une fiche synchronisée : le moteur met le compteur à jour et planifie l'envoi. */
export const SYNC_LOCAL_WRITE_EVENT = 'nexxus:sync-local-write';

const SYNCED_TABLES = new Set([
  'tenants',
  'salaries',
  'bulletins',
  'ecritures',
  'factures',
  'centres_analytiques',
]);

/** Signale une écriture locale (sans effet hors navigateur). Ne dépend ni du réseau ni de la synchro. */
export function signalLocalWrite(tableName: string): void {
  if (typeof window === 'undefined' || !SYNCED_TABLES.has(tableName)) return;
  try {
    window.dispatchEvent(new Event(SYNC_LOCAL_WRITE_EVENT));
  } catch {
    /* la saisie ne doit jamais dépendre de ce signal */
  }
}
